import React from 'react';
import { UTButton } from '@widergy/energy-ui';
import { useDispatch } from 'react-redux';
import { string } from 'prop-types';

import { message } from 'utils/stringUtils';
import { ROUTES } from 'constants/routes';
import { actionCreators as userFormActions } from 'redux/userFormHandlers';
import { PROCEDURE } from 'constants/userForms';

import styles from './styles.module.scss';

const UTButtonFieldLink = ({ description }) => {
  const dispatch = useDispatch();
  const openNewForm = () => dispatch(userFormActions.createForm(description, PROCEDURE, ROUTES.NEW_FORM));
  return (
    <UTButton primary onPress={openNewForm} className={styles.formLink}>
      {message('FormCreator:goToProcedure')}
    </UTButton>
  );
};

UTButtonFieldLink.propTypes = {
  description: string
};

export default UTButtonFieldLink;
